/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Untitled page',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Create a new page and insert it as a link',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Create Confluence page',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Open in Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Your page has been created',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Page created',
  'editorExtensionLinkCreate.confluencePage.title': 'Create new page',
  'editorExtensionLinkCreate.genericError.description': 'Refresh the page and try again.',
  'editorExtensionLinkCreate.genericError.title': 'Something went wrong',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    'Create an issue inline and insert the issue as a link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Create Jira issue',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Open in Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Your issue has been created',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Issue created',
  'editorExtensionLinkCreate.jiraIssue.title': 'Create new issue',
  'editorExtensionLinkCreate.keyword.create': 'create',
  'editorExtensionLinkCreate.keyword.issue': 'issue',
  'editorExtensionLinkCreate.keyword.new': 'new',
  'editorExtensionLinkCreate.keyword.page': 'page',
  'editorExtensionLinkCreate.keyword.publish': 'publish',
  'editorExtensionLinkCreate.keyword.raise': 'raise',
  'editorExtensionLinkCreate.keyword.space': 'space',
  'editorExtensionLinkCreate.keyword.ticket': 'ticket',
};
